import { createContext } from "react";

const PokemonContext = createContext();

export default PokemonContext;
